// extracted by mini-css-extract-plugin
export default {"textareaBox":"TextArea_textareaBox__94QfV","textareaBoxHeader":"TextArea_textareaBoxHeader__JHxDf","label":"TextArea_label__gfVw5","textarea":"TextArea_textarea__9vLsa"};